module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberlistitem"
  }, [(_vm.memberlistitem.pics.length > 0) ? _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.memberlistitem.pics[0].url,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_c('div', {
    staticClass: "describe_name"
  }, [_vm._v(_vm._s(_vm.memberlistitem.title))]), _vm._v(" "), _c('div', {
    staticClass: "describe_duty"
  }, [_vm._v(_vm._s(_vm.memberlistitem.desc))]), _vm._v(" "), _c('div', {
    staticClass: "describe_button"
  }, [_c('div', {
    staticClass: "describe_but_tel"
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "100",
      "trigger": "click",
      "content": _vm.memberlistitem.extra_data[0].value
    }
  }, [_c('p', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("电话")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "describe_but_weixin"
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "wx_code_area_for_memberlistitem"
  }, [(_vm.memberlistitem.extra_data[1].value.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.memberlistitem.extra_data[1].value[0].url,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "#",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("微信")])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2c7aefe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listItem/MemberListItem.vue
// module id = 1333
// module chunks = 0